module.exports = __webpack_public_path__ + "static/media/danger.1878268f.svg";